<template>
	<div class="full">
		<vxe-table ref="footeronlinegoods" :data="tableData" height="90%" border :tooltip-config="{showAll:true}" show-overflow
			:filter-config="{}" :row-config="{isHover: true}" :loading="loading">
			<vxe-column type="seq" width="60"></vxe-column>
			<vxe-column sortable field="shop" title="店铺" :filters="shopOptions" :filter-multiple="false"></vxe-column>
			<vxe-column sortable field="code" title="商品id"></vxe-column>
			<vxe-column sortable show-overflow field="name" title="标题"></vxe-column>
			<vxe-column sortable field="price" title="价格"></vxe-column>
			<vxe-column sortable field="skuid" title="SKUID"></vxe-column>
			<vxe-column sortable field="goodsname" title="sku名称"></vxe-column>
			<vxe-column sortable field="goodscode" title="sku编码">
				<template #default="{ row }">
					<el-link type="primary" style="font-size: 12px;" @click="getgoodsidbygroupcode(row)">
						{{row.goodscode}}</el-link>
				</template>
			</vxe-column>
			<vxe-column sortable field="nums" title="数量"></vxe-column>
			<vxe-column show-overflow field="link" title="商品链接">
				<template #default="{ row }">
					<el-link v-if="row.link" type="primary" style="font-size: 12px;" :href="row.link"
						target="_blank">跳转</el-link>
					<el-link v-else type="info" style="font-size: 12px;" disabled>跳转</el-link>
				</template>
			</vxe-column>
		</vxe-table>
	</div>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	export default {
		name: 'onlineIndex',
		props: {
			row: {
				type: Object,
				default: () => {
					return {}
				}
			},
			list: {
				type: Object,
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				loading:false,
				allAlign: null,
				tableData: [],
				shopOptions: []
			}
		},
		watch: {
			row(){
				this.getonline()
			}
		},
		created() {

		},
		mounted() {
			// if (this.row) {
			// 	this.getonline()
			// } else {
			// 	this.tableData = []
			// }
		},
		computed: {

		},

		methods: {
			getonline() {
				if(this.row){
					this.loading = true
					this.$api.goods.getonlineinfo(this.row.id).then((res) => {
						this.tableData = res
						let shop = res.map((item) => {
							return item.shop
						})
						shop = [...new Set(shop)]
						shop = shop.map((item)=>{
							return {
								label:item,
								value:item,
							}
						})
						this.shopOptions = shop
						this.$refs.footeronlinegoods.setFilter('shop',shop)
						console.log(this.shopOptions)
						this.loading = false
					},()=>{
						this.loading = false
					})
				}else{
					this.tableData = []
				}
			},
			getgoodsidbygroupcode(row) {
				this.$api.goods.getgoodsidbygroupcode(row.goodscode).then((res) => {
					this.list.getGrid().commitProxy('query', {
						code: res.join(','),
						currentPage: -1
					})
				})
			}
		},
		components: {

		}
	}
</script>